 import VueJwtDecode from 'vue-jwt-decode'
 
let  accessToken= localStorage.getItem('accessToken') ;
let role='Public' ;
class AuthService     {
     
     getRole(){
      
         
          if(accessToken==null)
        {
          accessToken = localStorage.getItem('accessToken') ;
        }
        if(accessToken!=null){
             role=VueJwtDecode.decode(accessToken).roles[0] ; 
         }
       
         return role ;
        
    }
    setrole(){
        if(localStorage.getItem('Role'))
        localStorage.setItem('Role',VueJwtDecode.decode(accessToken).roles[0])
    }
    initRole(){
      role='Public'
      accessToken=null ;
      
    }

    logOut(){
      if(localStorage.getItem('accessToken'))
      {
          localStorage.removeItem('accessToken')
      }
  }
    isAuthenticated() {
       if(accessToken==null)
      return false ;
      var dateExp=0;
      if(accessToken!=null)
     {
        dateExp=VueJwtDecode.decode(accessToken).exp ;
        
        console.log(new Date(VueJwtDecode.decode(accessToken).exp*1000))
     }
        return (
           Date.now() < dateExp*1000 && localStorage.getItem("accessToken")!=null);
    }
   
}
 
 
export default new AuthService();
